import { useContext, useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import Spinner from '../../UI/Modal/Spinner';
import Zaglavlje from './components/Zaglavlje';
import { TabContext } from '../../../Context/TabContext';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const INITIAL_VALUES = {
  // datumOd: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  datumOd: new Date(new Date().getFullYear(), 0, 1),
  datumDo: new Date(),
  statusZahteva: [],
};

const RadniNalozi = ({ novi, handleNovi, handleDisableBtnNovi }) => {
  const { t, i18n } = useTranslation();
  const { getData, isLoading } = useHttp('');
  const { getData: vratiStatuseData } = useHttp('');
  const [gridData, setGridData] = useState([]);
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const [filterValues, setFilterValues] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [savedFilter, setSavedFilter] = useState('');
  const { addTab } = useContext(TabContext);
  const [idRadniNalog, setIdRadniNalog] = useState(0);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localFormValues = dataLocal?.filterValues
    ? dataLocal?.filterValues
    : {};
  const localSearchFilter = dataLocal?.savedFilter
    ? dataLocal?.savedFilter
    : '';

  useEffect(() => {
    const tab = {
      type: 75,
      title: 'Radni nalozi',
      icon: 'fas fa-file-signature',
      filterValues: filterValues,
      savedFilter: savedFilter,
    };
    onTabChange(tab);
  }, [filterValues, savedFilter]);
  useEffect(() => {
    if (Object.keys(localFormValues).length > 0) {
      setFilterValues({
        ...localFormValues,
      });
    }
    if (localSearchFilter !== '') {
      setSavedFilter(localSearchFilter);
    }
  }, []);

  useEffect(() => {
    if (novi) {
      const tab = {
        title: 'Radni nalog',
        icon: 'fas fa-clipboard',
        type: 10012,
      };
      addTab(tab);
      handleNovi(false);
    }
  }, [novi]);
  useEffect(() => {
    if (localStorage.idFirme !== '1') {
      handleDisableBtnNovi({ id: activeComponent, disabled: true });
    }
  }, []);

  const vratiGrid = async (initList = null) => {
    const config = {
      url: urls.GET_RADNE_NALOGE_FILTER,
      method: 'POST',
      data: {
        datumOd:
          Object.keys(localFormValues).length === 0
            ? filterValues.datumOd
            : localFormValues.datumOd,
        datumDo:
          Object.keys(localFormValues).length === 0
            ? filterValues.datumDo
            : localFormValues.datumDo,
        lista: initList !== null ? initList : filterValues.statusZahteva,
        idKupca: +localStorage.idFirme,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);

    if (response) {
      setGridData(response);
    }
  };

  useEffect(() => {}, [filterValues]);
  const handlePretrazi = () => {
    vratiGrid();
  };
  const handleOpenDeleteDialog = (id) => {
    setIdRadniNalog(id);
    setOpenDeleteDialog(true);
  };
  const handleEditData = (item) => {
    const tab = {
      title: 'Radni nalog',
      icon: 'fas fa-clipboard',
      type: 10012,
      data: item,
    };
    addTab(tab);
  };

  const handleOpenPregledServisaKlijenti = (item) => {
    const tab = {
      title: 'Pregled servisa',
      icon: 'fas fa-clipboard',
      type: 10019,
      data: { ...item, samoWorkReportovi: true },
    };
    addTab(tab);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_RADNI_NALOG,
      data: { id: idRadniNalog },
    };
    const response = await getData(config);
    if (response > 0) {
      vratiGrid();
      setOpenDeleteDialog(false);
      toast.success('Uspešano obrisan podatak');

      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  const handleSvi = async () => {
    const result = await vratiStatuseData({
      url: urls.GET_STATUSI_COMBO,
      method: 'POST',
      data: { metadata: i18n.language },
    });

    if (result.length > 0) {
      setFilterValues((curr) => {
        return { ...curr, statusZahteva: result };
      });
    }
    setFilterValues((curr) => {
      return { ...curr, datumOd: '2024-01-01', datumDo: new Date() };
    });

    const config = {
      url: urls.GET_RADNE_NALOGE_FILTER,
      method: 'POST',
      data: {
        datumOd: '2024-01-01',
        datumDo: new Date(),
        lista: result,
        idKupca: +localStorage.idFirme,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);

    if (response) {
      setGridData(response);
    }
  };
  const onSearchChange = (newValue) => {
    setSavedFilter(newValue);
  };
  return (
    <div>
      {isLoading && <Spinner />}
      <Zaglavlje
        handlePretrazi={handlePretrazi}
        setFilterValues={setFilterValues}
        filterValues={filterValues}
        vratiGrid={vratiGrid}
        localFormValues={localFormValues}
        handleSvi={handleSvi}
      />
      <GridProvider
        data={gridData}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleOpenPregledServisaKlijenti={handleOpenPregledServisaKlijenti}
        handleEditData={handleEditData}
        onSearchChange={onSearchChange}
        savedFilter={savedFilter}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default RadniNalozi;
